<template>
  <div>
    <div v-if="!loading">
      <div v-if="order" class="flex flex-col">
        <div class="card w-full">
          <card-header :title="'Orden #' + order.id">
            <template #badge>
              <status-badge :status="order.status" :label="order.status === 'completed' ? 'Completada' : undefined" />
            </template>
          </card-header>

          <div class="detail-grid">
            <detail-field label="Fecha de creación" :value="formatDatetime(order.created_at)" />
            <detail-field label="Fecha de última actualización" :value="formatDatetime(order.updated_at)" />
          </div>

          <div v-if="order.status === 'completed'">
            <section-header title="Datos de Envío" />
            <div class="detail-grid">
              <detail-field label="URL de rastreo">
                <a
                  v-if="order.tracking_number"
                  class="detail-link"
                  :href="order.tracking_number"
                  target="_blank"
                  >{{ order.tracking_number ?? "-" }}</a
                >
                <p v-else class="detail-value">-</p>
              </detail-field>

              <detail-field label="URL de rastreo" :value="order.tracking_url" />
            </div>
          </div>

          <div v-for="item in order.items" :key="item.id" class="flex mt-4">
            <img
              :src="getImage(item)"
              alt=""
              class="rounded-t-lg w-20 h-20 aspect-square object-contain object-center bg-white mr-4"
            />

            <div>
              <router-link
                :to="{
                  name: 'productsDetail',
                  params: { id: item.product.id },
                }"
                class="underline system-button"
                >{{ item.product.name }}</router-link
              >
              <p>
                Precio unitario:
                {{ integerToCurrency(item.product.unit_price) }}
              </p>
              <p>Cantidad: {{ item.quantity }}</p>
            </div>
          </div>

          <div class="flex justify-between mt-6">
            <p class="text-sm font-medium">Subtotal:</p>
            <p class="text-sm font-medium">
              {{ integerToCurrency(order.total - order.shipping_price) }}
            </p>
          </div>

          <div class="flex justify-between mt-2">
            <p class="text-sm font-medium">Precio de envío:</p>
            <p class="text-sm font-medium">
              {{ integerToCurrency(order.shipping_price) }}
            </p>
          </div>
          <div class="flex justify-between mt-2">
            <p class="text-sm font-semibold">Total:</p>
            <p class="text-sm font-semibold">
              {{ integerToCurrency(order.total) }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
import api from "@/api";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Product Order Detail",

  data() {
    return {
      order: null,
      loading: false,
      loadingSend: false,
      defaultImage: require("@/assets/paw.png"),
      form: {
        tracking_number: "",
        tracking_url: "",
      },
    };
  },

  mixins: [validationErrors],

  created() {
    this.$store.commit("setSelectedTab", "productOrders");

    this.loadProductOrder();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    async loadProductOrder() {
      this.loading = true;

      try {
        this.order = await api.productOrders.getById(this.$route.params.id);
        this.$store.commit('setBreadcrumbLabel', {
          routeName: this.$route.name,
          label: 'Orden #' + this.order.id,
        });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
        this.$router.push({ name: "productOrdersIndex" });
      }

      this.loading = false;
    },

    getImage(item) {
      if (!item.product.image_url) {
        return this.defaultImage;
      }

      return item.product.image_url;
    },

    validateForm() {
      this.errors = {};

      if (!this.form.tracking_number) {
        this.errors["tracking_number"] = ["Campo requerido"];
      }

      if (!this.form.tracking_url) {
        this.errors["tracking_url"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async send() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      this.loadingSend = true;

      try {
        const response = await api.productOrders.send(this.order.id, this.form);
        this.$store.dispatch("successSnack", response.message);
        this.loadProductOrder();
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingSend = false;
    },
  },
};
</script>